import { Document, Font, Page, StyleSheet } from '@react-pdf/renderer';
import React from 'react';
import NotoNastaliqUrdu from "../../assets/fonts/Noto/JameelNooriNastaleeqRegular.ttf";
import InvoiceItemsTable from './InvoiceItemsTable';
import InvoiceNo from './InvoiceNo';
import InvoiceTray from './InvoiceTray';
import InvoiveSignature from './InvoiveSignature';


Font.register({
  family: "NotoNastaliqUrdu",
  fonts: [
    {
      src: NotoNastaliqUrdu,
      fontWeight: 400,
    },
  ]
});

const styles = StyleSheet.create({
  page: {
    // fontFamily: 'NotoNastaliq',
    fontSize: 11,
    // paddingTop: 2,
    // paddingBottom: 16,
    paddingLeft: 60,
    paddingRight: 60,
    lineHeight: 1,
    flexDirection: 'column',
    paddingBottom: 58,
    paddingTop: 20,

  },
  logo: {
    width: 90,
    height: 80,
    marginLeft: 'auto',
    marginRight: 'auto'
  }
});

const Invoice = ({ invoice }) => {
  return (
  <Document>
    <Page size="A4" style={styles.page} >
      {/* <Image style={styles.logo} src={logo} /> */}
      {/* <InvoiceTitle title='National Bake Factory' /> */}
      <div style={{justifyContent:'space-between',width:'100%',flexDirection:'row',}}> 
      <InvoiceNo invoice={invoice} />
      </div>
      <InvoiceItemsTable invoice={invoice} />
      <div style={{justifyContent:'space-between',width:'100%',flexDirection:'row',marginTop:10}}>
      <InvoiceTray invoice={invoice} />
      </div>
      <div style={{justifyContent:"flex-end",width:'100%',flexDirection:'row',marginTop:45}}>
      <InvoiveSignature invoice={invoice} />
      </div>
    </Page>
  </Document>
  )
};

export default Invoice